import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

import Navigation from "./Navigation";

const drawerWidth = 290;

const DrawerDesktop = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(0),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(0),
      },
    }),
  },
}));

const AppDrawer = ({ open, toggleDrawer, onPageChange, isMobile = false, openModal }) => {
  const container = typeof window !== "undefined" ? window.document.body : undefined;

  if (isMobile) {
    return (
      <MuiDrawer
        container={container}
        variant="temporary"
        open={open}
        onClose={toggleDrawer}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
      >
        <Navigation
          open={open}
          toggleDrawer={toggleDrawer}
          handlePagina={onPageChange}
          handlePaginaMobile={onPageChange}
          isMobile={isMobile}
          openModal={openModal}
        />
      </MuiDrawer>
    );
  }

  return (
    <DrawerDesktop variant="permanent" open={open}>
      <Navigation
        open={open}
        toggleDrawer={toggleDrawer}
        handlePagina={onPageChange}
        handlePaginaMobile={onPageChange}
        isMobile={isMobile}
        openModal={openModal}
      />
    </DrawerDesktop>
  );
};

export default AppDrawer;
